import * as moment from 'moment';
import { Media } from './media';
import { QuizQuestionAnswer } from './quizQuestionAnswer';

export class QuizQuestion {
    id: number;
    question: string;
    quiz_id: number;
    answer_id: number;
    media_id: number;
    media: Media;
    answers: QuizQuestionAnswer[];
    question_image:string;
    updated_at: moment.Moment;
    created_at: moment.Moment;
    constructor(question?) {
        if (question) {
            this.id = question.id;
            this.question = question.question;
            this.quiz_id = question.quiz_id;
            this.answer_id = question.answer_id;
            this.media_id = question.media_id;
            this.media = new Media(question.media);
            let answersArray = [];
            question.answers.forEach(ans=>{
                answersArray.push(new QuizQuestionAnswer(ans));
            })
            this.question_image=question.question_image;
            this.answers = answersArray;
            this.created_at = moment(question.created_at);
            this.updated_at = moment(question.updated_at);
        }
    }
}
